'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wixBridgeActions = [{
    type: 'SET_LOCATIONS',
    propTypes: {
        locations: _proptypes2.default.array
    }
}, {
    type: 'SET_CURRENT_LOCATION',
    propTypes: {
        currentLocation: _proptypes2.default.string
    }
}, {
    type: 'LOAD_LOCATIONS',
    propTypes: {
        orgId: _proptypes2.default.string
    }
}, {
    type: 'LOAD_COMPACT_MENUS',
    propTypes: {
        orgId: _proptypes2.default.string,
        locale: _proptypes2.default.string,
        locations: _proptypes2.default.array
    }
}, {
    type: 'SET_COMPACT_MENUS',
    propTypes: {
        compactMenusList: _proptypes2.default.array
    }
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(wixBridgeActions, 'LOCATIONS_');
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(wixBridgeActions, 'LOCATIONS_');